import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FLink } from '@components';
import { CaminhosPDFService } from '@services';
import { toast } from 'react-toastify';

export const OpcaoInstitutoPage = () => {
  const { matricula, token } = useSelector((state) => state.user);
  const [msgErro, setMsgErro] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const service = new CaminhosPDFService();

    service
      .getOpcaoInstituto(matricula)
      .then((res) => {
        if (res.data.msgConsistencia) {
          setMsgErro(res.data.msgConsistencia);
        } else {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Opção por Instituto.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch(() => {
        toast.error('Erro ao obter dados');
      });
  }, [matricula, token]);

  return (
    !msgErro && (
      <div className="card">
        <div className="card-body pb-0">
          <FLink
            className="justify-content-start mb-32"
            iconLeft="icon-arrow_back"
            onClick={() => navigate(-1)}
          >
            voltar
          </FLink>
          <h3 className="ts-20 fw-bold mb-2">Atenção</h3>
          <p className="ts-14 text-muted mb-32">{msgErro}</p>
        </div>
      </div>
    )
  );
};
